<div class="container" style="margin-top: 7%;">
  <div class="row">
    <div class="card">
      <h3 [innerHTML]="paragraphe.titre | safeHtml"></h3>
      <p [innerHTML]="paragraphe.body | safeHtml"></p>
      <a href="{{paragraphe.link}}" routerLinkActive="active" class="nav-link active">LIRE PLUS</a>
    </div>

  </div>
</div>